import React from 'react';

type Props = {
  width?: string;
  height?: string;
  strokeColor?: string;
  /**
   * Defaults to 1 — SVG's own default — so existing consumers (the LinkedIn
   * preview) render exactly as before. Pass a heavier value where the glyph
   * sits small on a filled button and a hairline reads as washed out.
   */
  strokeWidth?: string;
};
const SendIcon = (props: Props) => {
  const {
    width = '17',
    height = '18',
    strokeColor = 'currentColor',
    strokeWidth = '1',
  } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 17 18" fill="none">
      <path
        d="M7.26923 10.2308L0.5 7.15385L16.5 1L10.3462 17L7.26923 10.2308Z"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.26953 10.2309L10.9618 6.53857"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SendIcon;
